import React from "react";
import { useParams } from "react-router-dom";

const POLICIES = {
  privacy: { title: "Privacy Policy", body: [
    "IAH respects your privacy. This policy explains what information we collect, how we use it, and your choices.",
    "Information we collect: contact details, shipping address, order history, and information you provide when contacting us or subscribing.",
    "How we use it: to process orders, provide support, improve our products, and — only with your consent — send marketing communications.",
    "We never sell your personal data. Payment information is processed securely by our payment partner and is not stored on our servers.",
    "[PLACEHOLDER: Client to add registered company name, address and data-protection contact.]",
  ]},
  terms: { title: "Terms & Conditions", body: [
    "By using this website and placing an order, you agree to these terms.",
    "All prices are listed in INR and inclusive of applicable taxes unless stated otherwise.",
    "We reserve the right to refuse or cancel orders in cases of suspected fraud or errors in pricing or availability.",
    "[PLACEHOLDER: Client to add governing law, jurisdiction and registered entity details.]",
  ]},
  shipping: { title: "Shipping Policy", body: [
    "Orders are typically processed within 1–2 business days.",
    "Free shipping is available on orders above ₹999. A flat fee applies to smaller orders.",
    "Delivery timelines vary by location. Tracking details are shared once your order is shipped.",
    "Serviceability is checked at checkout based on your PIN code.",
    "[PLACEHOLDER: Client to confirm courier partners and specific delivery timelines.]",
  ]},
  returns: { title: "Return & Exchange Policy", body: [
    "At IAH, every product is crafted with care and passes strict quality checks before it reaches you. If something isn't right, we're here to make it right through our return and exchange process.",
    "Eligibility: You may request a return or exchange within 7 days of delivery, provided the product is unused, unopened and in its original, sealed packaging with all tags, seals and free gifts intact.",
    "Exchanges: If you received a damaged, defective, or wrong item, we will happily exchange it for the same product or an equivalent of your choice at no additional cost. Please raise the request within 48 hours of delivery and share a clear photo/unboxing video of the item and packaging to help us process it faster.",
    "How to request: Go to My Account → Orders and select 'Return / Exchange', or email us at connect@theiah.in with your order number and reason. Our team will guide you through the pickup or self-ship process.",
    "Non-returnable items: For health, hygiene and safety reasons, opened or used skincare, cosmetics, fragrances, and any items marked non-returnable cannot be returned or exchanged unless they arrived damaged or defective.",
    "Refunds (where applicable): Once your returned item is received and passes quality inspection, an approved refund is initiated to your original payment method within 5–7 business days. Prepaid order shipping charges are non-refundable; any exchange reships free of cost.",
    "Cancellations: Orders can be cancelled before they are shipped for a full refund. Once shipped, an order cannot be cancelled but may be eligible for return or exchange as per this policy.",
    "For any questions about a return or exchange, reach us at connect@theiah.in or +91 6003840997 (Mon–Sat, 10am–6pm IST). We're always happy to help.",
  ]},
  cancellation: { title: "Cancellation Policy", body: [
    "Orders can be cancelled before they are shipped by contacting support with your order number.",
    "Once shipped, an order cannot be cancelled but may be eligible for return.",
    "[PLACEHOLDER: Client to confirm cancellation cut-off and process.]",
  ]},
  cookies: { title: "Cookie Policy", body: [
    "We use cookies to keep your cart, remember preferences and understand how the site is used.",
    "You can control cookies through your browser settings.",
    "[PLACEHOLDER: Client to add analytics/cookie vendor details and consent mechanism.]",
  ]},
};

export default function Policy() {
  const { slug } = useParams();
  const p = POLICIES[slug] || POLICIES.privacy;
  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-10 py-16 min-h-[60vh]">
      <span className="eyebrow text-moss">Legal</span>
      <h1 className="serif text-5xl mt-2 mb-3" data-testid="policy-title">{p.title}</h1>
      <p className="text-xs text-forest/40 mb-10">Last updated {new Date().toLocaleDateString("en-IN", { month: "long", year: "numeric" })}</p>
      <div className="space-y-6">
        {p.body.map((para, i) => (
          <p key={i} className={`leading-relaxed ${para.startsWith("[PLACEHOLDER") ? "text-brown/70 italic text-sm bg-beige/40 p-4" : "text-forest/75"}`}>{para}</p>
        ))}
      </div>
    </div>
  );
}
